export enum ExpressionKinds {
  Calculation = 1,
  Conditional = 2,
  DateDuration = 3,
  TimeSpan = 4,
  DateComparison = 5,
}
